import { DEFAULT_TRANSITION } from '../../styles/constants';

export const TOOLTIP_ANIMATION = {
  visible: {
    y: 0,
    opacity: 1,
    transition: DEFAULT_TRANSITION,
  },
  hidden: {
    y: -20,
    opacity: 0,
    transition: DEFAULT_TRANSITION,
  },
};
